import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const pageLimit = 10;

export default function usePaginatedContent(pageNumber) {
  const reduxState = useSelector((state) => state);
  const [paginatedContent, setPaginatedContent] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    setPaginatedContent([]);
  },[reduxState.allContent.filteredContent])

  useEffect(() => {
    setLoading(true);
    setError(false);

    //set paginated results from filtered content
    const startIndex = (pageNumber - 1) * pageLimit,
      endIndex = pageNumber * pageLimit;
    setPaginatedContent((prevContent) => [
      ...prevContent,
      ...reduxState.allContent.filteredContent.slice(startIndex, endIndex),
    ]);
    setHasMore(reduxState.allContent.filteredContent.length > 0);
    setLoading(false);
  }, [pageNumber,reduxState.allContent.filteredContent]);

  return { loading, error, paginatedContent, hasMore };
}
